import axios from "axios";
import Cookies from "js-cookie";
import { getSessionLogoutRole } from "../auth/sessionLogout";

axios.defaults.withCredentials = true;

const trim = (s) => (s ? String(s).replace(/\/+$/, "") : "");
const isDev = import.meta.env.VITE_ENABLE_API_LOGS === "true";

const DEFAULT_GATEWAY =
  trim(import.meta.env.VITE_GATEWAY_URL) ||
  (typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.host}`
    : "");

export const BASE_URLS = {
  RADIO_BROWSER: "https://de1.api.radio-browser.info/json",
  WEATHER: "https://api.open-meteo.com/v1",
  GATEWAY: trim(import.meta.env.VITE_GATEWAY_URL) || DEFAULT_GATEWAY,

  USERS: trim(import.meta.env.VITE_USER_SERVICE_URL) || `${DEFAULT_GATEWAY}/users`,
  // Les domaines médicaux ne sont jamais appelés directement par le navigateur.
  MEDICAL: `${DEFAULT_GATEWAY}/medical-information`,
  CYCLES: trim(import.meta.env.VITE_CYCLE_SERVICE_URL) || `${DEFAULT_GATEWAY}/cycles`,
  RELATIVES:
    trim(import.meta.env.VITE_RELATIVES_SERVICE_URL) || `${DEFAULT_GATEWAY}/relatives`,

  AUTH: trim(import.meta.env.VITE_MS_AUTH) || DEFAULT_GATEWAY,

  POSTS: trim(import.meta.env.VITE_MS_POSTS) || `${DEFAULT_GATEWAY}/posts`,
  LIKES: trim(import.meta.env.VITE_LIKES_SERVICE_URL) || `${DEFAULT_GATEWAY}/likes`,
  COMMENTS:
    trim(import.meta.env.VITE_COMMENTS_SERVICE_URL) || `${DEFAULT_GATEWAY}/comments`,

  MEDICATION: `${DEFAULT_GATEWAY}/medication`,
  MEDICATIONS_DATABASE:
    trim(import.meta.env.VITE_MEDICATIONS_DATABASE_SERVICE_URL) || DEFAULT_GATEWAY,

  ANALYSE: trim(import.meta.env.VITE_MS_ANALYSE) || `${DEFAULT_GATEWAY}/analyse`,
  SIGNAL: trim(import.meta.env.VITE_MS_SIGNAL) || `${DEFAULT_GATEWAY}/signal`,

  PRESCRIPTION: trim(import.meta.env.VITE_MS_PRESCRIPTION) || `${DEFAULT_GATEWAY}`,

  EMERGENCY:
    trim(import.meta.env.VITE_EMERGENCYCONTACT_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/emergency-contact`,

  PLACES: trim(import.meta.env.VITE_MS_PLACES) || `${DEFAULT_GATEWAY}/places`,
  MESSAGES:
    trim(import.meta.env.VITE_MESSAGES_SERVICE_URL) || `${DEFAULT_GATEWAY}/messages`,

  REGISTER_DOCTOR:
    trim(import.meta.env.VITE_REGISTERDOCTOR_URL) ||
    `${DEFAULT_GATEWAY}/register-doctors`,

  DOCTOR_AUTH: trim(import.meta.env.VITE_LOGINDOCTOR_URL) || `${DEFAULT_GATEWAY}/auth`,

  DISPONIBILITY:
    trim(import.meta.env.VITE_AVAILABILITY_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/disponibilite`,

  DOCTORPROFILE:
    trim(import.meta.env.VITE_DOCTORPROFILE_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/doctor-profiles`,

  RDV: trim(import.meta.env.VITE_RDV_SERVICE_URL) || `${DEFAULT_GATEWAY}/rendezvous`,

  HEALTHBOT: trim(import.meta.env.VITE_MEDICAL_ASSISTANT_PATH) || DEFAULT_GATEWAY,

  EXTRACTION: `${DEFAULT_GATEWAY}/extraction`,

  EVENTS: trim(import.meta.env.VITE_EVENTS_SERVICE_URL) || `${DEFAULT_GATEWAY}/events`,

  VITALS:
    trim(import.meta.env.VITE_VITALS_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/vital-signs`,

  MODERATION:
    trim(import.meta.env.VITE_MODERATION_SERVICE_URL) ||
    DEFAULT_GATEWAY,

  DOCTORS: trim(import.meta.env.VITE_DOCTORS_SERVICE_URL) || `${DEFAULT_GATEWAY}/doctors`,

  CONSULTATION:
    trim(import.meta.env.VITE_CONSULTATION_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/consultations`,

  SPECIALITY: `${DEFAULT_GATEWAY}/nephrology`,
  PULMONOLOGY: `${DEFAULT_GATEWAY}/pulmonology`,

  NOTIFICATIONS:
    trim(import.meta.env.VITE_NOTIFICATION_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/notifications`,

  FOLLOWS: trim(import.meta.env.VITE_FOLLOWS_SERVICE_URL) || `${DEFAULT_GATEWAY}/follows`,

  CONNECTIONS:
    trim(import.meta.env.VITE_CONNECTIONS_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/connections`,

  INTERRACTION:
    trim(import.meta.env.VITE_INTERRACTION_SERVICE_URL) || `${DEFAULT_GATEWAY}`,

  SOUS_PROFILE:
    trim(import.meta.env.VITE_SOUS_PROFILE_URL) || `${DEFAULT_GATEWAY}/sous-profiles`,

  // ✅ Admin should stay on the local gateway by default in dev,
  // and only use the env override when explicitly configured.
  ADMIN: trim(import.meta.env.VITE_ADMIN_DASHBOARD_URL) || DEFAULT_GATEWAY,

  CNSS: trim(import.meta.env.VITE_CNSS_URL) || `${DEFAULT_GATEWAY}/cnss/cards`,

  // ✅ CORRIGÉ : FEEDBACK a sa propre clé env, avec fallback vers ms-admin aussi
  FEEDBACK:
    trim(import.meta.env.VITE_ADMIN_DASHBOARD_URL) || `${DEFAULT_GATEWAY}/admin/feedbacks`,
  ASSISTANTS:trim(import.meta.env.VITE_MEDICAL_ASSISTANT_PATH) || `${DEFAULT_GATEWAY}/assistants`,

    
};

const FORBIDDEN_REQUEST_FIELDS = new Set([
  "role",
  "userRole",
  "id",
  "_id",
  "userId",
  "doctorId",
  "medecinId",
  "patientId",
  "uuid",
  "pgId",
  "createdAt",
  "updatedAt",
  "raw",
]);

export const sanitizeRequestData = (data, allowedFields = new Set()) => {
  if (!data || typeof data !== "object") return data;

  if (typeof FormData !== "undefined" && data instanceof FormData) {
    const next = new FormData();
    Array.from(data.entries()).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (
        FORBIDDEN_REQUEST_FIELDS.has(String(key)) &&
        !allowedFields.has(String(key))
      ) return;
      next.append(key, value);
    });
    return next;
  }

  if (Array.isArray(data)) {
    return data.map((item) => sanitizeRequestData(item, allowedFields));
  }

  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) => {
      if (value === undefined || value === null) return false;
      if (
        FORBIDDEN_REQUEST_FIELDS.has(String(key)) &&
        !allowedFields.has(String(key))
      ) return false;
      return true;
    })
  );
};

const ensureSuffix = (key, suffix) => {
  const val = BASE_URLS[key];
  if (!val) return;
  const clean = trim(val);
  if (clean.endsWith(suffix)) { BASE_URLS[key] = clean; return; }
  BASE_URLS[key] = `${clean}${suffix.startsWith("/") ? "" : "/"}${suffix}`;
};

ensureSuffix("DOCTORPROFILE", "/doctor-profiles");
ensureSuffix("NOTIFICATIONS", "/notifications");
ensureSuffix("FOLLOWS", "/follows");
ensureSuffix("CONNECTIONS", "/connections");

// ─── Acting subprofile helpers ────────────────────────────────────────────────

const getActingAccessToken = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem("actingSession");
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (session?.mode !== "subprofile") return null;
    return session.accessToken || session.access_token || null;
  } catch {
    return null;
  }
};

const getActingSubprofileId = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem("actingSession");
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (session?.mode !== "subprofile") return null;
    const value =
      session.actingAs?.id ||
      session.actingAs?._id ||
      session.actingAs ||
      session.profile?.id ||
      session.profile?._id ||
      session.profile?.subprofileId ||
      session.profile?.subProfileId;
    const clean = value == null ? "" : String(value).trim();
    return clean || null;
  } catch {
    return null;
  }
};

const getStoredValue = (storage, key) => {
  if (typeof window === "undefined") return null;
  try {
    return storage?.getItem(key) || null;
  } catch {
    return null;
  }
};

const getActiveSessionRole = () => {
  if (typeof window === "undefined") return null;
  return (
    getStoredValue(window.sessionStorage, "activeSessionRole") ||
    getStoredValue(window.localStorage, "userRole")
  );
};

const getPatientAccessToken = () => {
  if (typeof window === "undefined") return null;
  return (
    getActingAccessToken() ||
    getStoredValue(window.sessionStorage, "patientAccessToken") ||
    getStoredValue(window.localStorage, "patientAccessToken") ||
    Cookies.get("accessToken") ||
    Cookies.get("auth_token") ||
    Cookies.get("token") ||
    null
  );
};

const getDoctorAccessToken = () => {
  if (typeof window === "undefined") return null;
  return (
    Cookies.get("doctorAccessToken") ||
    Cookies.get("doctor_token") ||
    Cookies.get("doctorToken") ||
    Cookies.get("doctorJwt") ||
    getStoredValue(window.localStorage, "doctorAccessToken") ||
    getStoredValue(window.localStorage, "doctor_token") ||
    getStoredValue(window.localStorage, "doctorToken") ||
    getStoredValue(window.localStorage, "doctorJwt") ||
    null
  );
};

const getAssistantAccessToken = () => {
  if (typeof window === "undefined") return null;
  return (
    Cookies.get("assistantAccessToken") ||
    Cookies.get("assistantToken") ||
    getStoredValue(window.localStorage, "assistantAccessToken") ||
    getStoredValue(window.localStorage, "assistantToken") ||
    null
  );
};

// ─── Détection du rôle actif ──────────────────────────────────────────────────

const isDoctorSession = () => {
  if (typeof window === "undefined") return false;

  const storedRole = getActiveSessionRole();
  if (storedRole === "doctor") return true;
  if (storedRole === "patient") return false;

  const doctorToken =
    Cookies.get("doctorAccessToken") ||
    Cookies.get("doctor_token") ||
    Cookies.get("doctorToken") ||
    localStorage.getItem("doctorAccessToken") ||
    localStorage.getItem("doctor_token") ||
    localStorage.getItem("doctorToken") ||
    null;

  const patientToken = getPatientAccessToken();

  if (doctorToken && !patientToken) return true;
  if (!doctorToken && patientToken) return false;

  const path = window.location.pathname.toLowerCase();
  return (
    path.includes("/doctor") ||
    path.includes("/medecin") ||
    path.includes("/disponib") ||
    path.includes("/rendezvous") ||
    path === "/assistants" ||
    path.startsWith("/assistants/") ||
    path.includes("/logindoctor")
  );
};

const isAssistantSession = () => {
  if (typeof window === "undefined") return false;

  const storedRole = getActiveSessionRole();
  if (storedRole === "assistant") return true;

  const assistantToken =
    Cookies.get("assistantAccessToken") ||
    Cookies.get("assistantToken") ||
    localStorage.getItem("assistantAccessToken") ||
    localStorage.getItem("assistantToken") ||
    null;

  if (assistantToken) return true;

  const path = window.location.pathname.toLowerCase();
  return path.includes("/assistants") || path.includes("/loginassistant") || path.includes("/verifyassistantcode");
};

// ─── Redirection intelligente selon le rôle ───────────────────────────────────

const redirectToLogin = () => {
  if (typeof window === "undefined") return;

  const currentPath = window.location.pathname;
  const isDoctor =
    getSessionLogoutRole() === "doctor" || isDoctorSession();
  const loginPath = isDoctor ? "/LoginDoctor" : "/LoginPatient";

  if (currentPath.toLowerCase() === loginPath.toLowerCase()) return;

  if (isDoctor) {
    Cookies.remove("doctorAccessToken");
    Cookies.remove("doctor_token");
    Cookies.remove("doctorToken");
    localStorage.removeItem("doctorAccessToken");
    localStorage.removeItem("doctor_token");
    localStorage.removeItem("doctorToken");
  } else {
    Cookies.remove("accessToken");
    Cookies.remove("auth_token");
    Cookies.remove("token");
    localStorage.removeItem("patientAccessToken");
    sessionStorage.removeItem("patientAccessToken");
  }

  localStorage.removeItem("userRole");
  sessionStorage.removeItem("activeSessionRole");

  window.location.replace(loginPath);
};

const PATIENT_SESSION_PROBE_PATH = "/me"; // ms-authPatient (via BASE_URLS.USERS)
const DOCTOR_SESSION_PROBE_PATH = "/register-doctors/me"; // gateway (verifie 401)

// ─── Auth header ──────────────────────────────────────────────────────────────

const isPublicAuthRequest = (config) => {
  const requestUrl = `${config?.baseURL || ""}${config?.url || ""}`;
  return /(?:^|\/)auth\/(?:login|logout|verify-2fa|verify-code|resend-2fa-code|password\/request-reset|password\/verify-code|password\/reset|doctor\/login-dr|doctor\/logout|doctor\/verify|doctor\/request-reset|doctor\/reset-password|doctor\/resend-code)(?:[/?]|$)/i.test(
    requestUrl
  );
};

const attachAuthHeader = (config) => {
  config.headers = config.headers || {};
  const headers = config.headers;
  if (isPublicAuthRequest(config)) return config;

  const hasExplicitAuth = headers.Authorization || headers.authorization;
  const requestUrl = `${config?.baseURL || ""}${config?.url || ""}`;
  const isDoctorPage =
    typeof window !== "undefined" &&
    /(?:^|\/)(?:doctorPages|doctor|medecin)(?:\/|$)/i.test(
      window.location.pathname
    );
  const isPatientProfilePage =
    typeof window !== "undefined" &&
    /^\/profile\/[^/]+\/?$/i.test(window.location.pathname);

  const patientToken = getPatientAccessToken();

  const doctorToken = getDoctorAccessToken();
  const assistantToken = getAssistantAccessToken();

  // Treat certain API paths as "doctor-scoped" so we preferentially use the
  // doctor's access token when attaching Authorization header.
  // Add doctor-only paths here because they require a doctor token when
  // called from doctor views (avoid 401/403 Forbidden).
  const isDoctorMedicalRequest =
    (isDoctorSession() || isDoctorPage) &&
    /(?:^|\/)(?:medical-information|extraction|medication|rendezvous\/access-requests|cnss\/cards)(?:\/|$)/i.test(
      requestUrl,
    );
  const isDoctorScopedRequest =
    isDoctorMedicalRequest ||
    /(?:^|\/)(?:local-patients|rendezvous\/(?:doctor|access-requests\/doctor)|doctor-profiles|register-doctors|doctors|prescriptions|consultations|disponibilite|doctor)(?:\/|$)/i.test(
      requestUrl,
    );
  const shouldForceDoctorToken =
    !!doctorToken && /(?:^|\/)(?:assistants)(?:\/|$)/i.test(requestUrl);

  const activeRole = getActiveSessionRole();
  const isAssistant = isAssistantSession();

  // Shared pages reused by assistants may call doctor-scoped endpoints.
  // For assistant management routes, the doctor JWT must be used whenever it exists.
  //
  // For everything else (e.g. /rendezvous, /messages) the URL alone can't tell
  // us who's calling: those endpoints are shared between patients and doctors.
  // If a stale patient cookie is still sitting in the browser (left over from
  // an earlier patient session) it must not win over the doctor token while
  // the user is actively using the app as a doctor, or every doctor-only
  // route behind JwtDoctorGuard 401s. Defer to the active session role.
  const token = resolveEffectiveTokenForRequest({
    requestUrl,
    patientToken,
    doctorToken,
    assistantToken,
    activeRole,
    isAssistant,
    isDoctorCnssRequest:
      (isDoctorSession() || isDoctorPage) &&
      /(?:^|\/)cnss\/cards(?:\/|$)/i.test(requestUrl),
    isPatientCnssRequest:
      isPatientProfilePage &&
      /(?:^|\/)cnss\/cards(?:\/|$)/i.test(requestUrl),
  });

  if (!hasExplicitAuth && token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (isDoctorScopedRequest && isDev) {
    console.debug(
      `[API auth] doctor-scoped request to ${requestUrl}`,
      {
        doctorToken: Boolean(doctorToken),
        assistantToken: Boolean(assistantToken),
        patientToken: Boolean(patientToken),
        selectedToken: token
          ? token === doctorToken
            ? "doctor"
            : token === assistantToken
              ? "assistant"
              : "patient"
          : "none",
        explicitAuth: Boolean(hasExplicitAuth),
      }
    );
  }

  // Dev helper: if this request targets disponibilite, log which token is used
  if (isDev && /disponibilite/i.test(requestUrl)) {
    console.debug(`[API debug] disponibility request: ${requestUrl}`, {
      hasExplicitAuth: Boolean(hasExplicitAuth),
      doctorToken: Boolean(doctorToken),
      patientToken: Boolean(patientToken),
      assistantToken: Boolean(assistantToken),
      selected: token ? (token === doctorToken ? 'doctor' : token === assistantToken ? 'assistant' : 'patient') : 'none'
    });
  }

  if (isDoctorScopedRequest && !doctorToken && patientToken && isDev) {
    console.warn(
      `[API] Doctor-scoped request without doctor token; using patient token for ${requestUrl}`
    );
  }

  const actingSubprofileId = getActingSubprofileId();
  if (actingSubprofileId) {
    config.headers["X-Subprofile-Id"] =
      config.headers["X-Subprofile-Id"] || actingSubprofileId;
    config.headers["X-Acting-Subprofile-Id"] =
      config.headers["X-Acting-Subprofile-Id"] || actingSubprofileId;
  }

  return config;
};

// URL complète d'une requête, pour les logs (helper manquant auparavant :
// l'appeler dans l'intercepteur d'erreur levait un ReferenceError).
export const resolveEffectiveTokenForRequest = (options = {}) => {
  const normalized =
    typeof options === "string" ? { requestUrl: options } : options || {};

  const requestUrl = String(normalized.requestUrl || "");
  const patientToken = normalized.patientToken ?? getPatientAccessToken();
  const doctorToken = normalized.doctorToken ?? getDoctorAccessToken();
  const assistantToken = normalized.assistantToken ?? getAssistantAccessToken();

  const activeRole = normalized.activeRole ?? getActiveSessionRole();
  const isAssistant = normalized.isAssistant ?? isAssistantSession();
  const isDoctorPage =
    typeof window !== "undefined" &&
    /(?:^|\/)(?:doctorPages|doctor|medecin|disponib|rendezvous)(?:\/|$)/i.test(
      window.location.pathname,
    );
  const isDoctorCnssRequest =
    normalized.isDoctorCnssRequest ??
    (isDoctorPage && /(?:^|\/)cnss\/cards(?:\/|$)/i.test(requestUrl));
  const isPatientCnssRequest =
    normalized.isPatientCnssRequest ??
    (typeof window !== "undefined" &&
      /^\/profile\/[^/]+\/?$/i.test(window.location.pathname) &&
      /(?:^|\/)cnss\/cards(?:\/|$)/i.test(requestUrl));
  const isDoctorScopedRequest =
    (normalized.isDoctorScopedRequest ?? (isDoctorSession() || isDoctorPage)) &&
    /(?:^|\/)(?:medical-information|extraction|medication|local-patients|rendezvous\/(?:doctor|access-requests\/doctor)|doctor-profiles|register-doctors|doctors|prescriptions|consultations|disponibilite|doctor|assistants|cnss\/cards)(?:\/|$)/i.test(
      requestUrl,
    );

  if (isPatientCnssRequest) return patientToken;
  if (isDoctorCnssRequest && doctorToken) return doctorToken;
  if (activeRole === "patient") return patientToken || doctorToken || assistantToken;
  if (activeRole === "doctor") return doctorToken || patientToken || assistantToken;
  if (isAssistant) return assistantToken || doctorToken || patientToken;
  if (isDoctorSession() || isDoctorScopedRequest) return doctorToken || patientToken || assistantToken;
  if (!!doctorToken && /(?:^|\/)(?:assistants)(?:\/|$)/i.test(requestUrl)) return doctorToken;

  return patientToken || doctorToken || assistantToken;
};

const describeRequestUrl = (config) =>
  `${config?.baseURL || ""}${config?.url || ""}`;

// Endpoints réservés au médecin / à l'assistant, appelés depuis des écrans
// partagés (profil d'un médecin, agenda, dossier…).
const isDoctorOnlyUrl = (url) =>
  /(?:^|\/)(?:local-patients|doctor-profiles|register-doctors|prescriptions|consultations|disponibilite|doctor|doctors|rendezvous\/doctor)(?:\/|$)/i.test(
    String(url || "")
  );

// Session patient = jeton patient présent, aucun jeton médecin.
const isPatientOnlySession = () => {
  if (typeof window === "undefined") return false;

  const patientToken = getPatientAccessToken();

  const doctorToken =
    Cookies.get("doctorAccessToken") ||
    Cookies.get("doctor_token") ||
    Cookies.get("doctorToken") ||
    null;

  return Boolean(patientToken) && !doctorToken;
};

// ─── Confirmation d'expiration de session ─────────────────────────────────────
// Un 401 ne signifie pas forcement que la session est morte : il peut venir
// d'une ressource qui n'appartient pas a l'utilisateur ou d'un endpoint reserve
// a un autre role (ecrans partages patient / medecin / assistant).
// On verifie donc la session AVANT de supprimer les cookies et de rediriger.
// La requete de verification utilise un axios brut (sans intercepteur) pour
// eviter toute recursion.

const sessionProbeClient = axios.create({ withCredentials: true });
let sessionProbeRunning = false;

const currentSessionTokens = () => ({
  patient: getPatientAccessToken(),
  doctor:
    Cookies.get("doctorAccessToken") ||
    Cookies.get("doctor_token") ||
    Cookies.get("doctorToken") ||
    null,
});

/** true = session encore valide, false = session reellement expiree */
const isSessionStillValid = async () => {
  const { patient, doctor } = currentSessionTokens();
  const useDoctor = Boolean(doctor) && (!patient || isDoctorSession());
  const token = useDoctor ? doctor : patient;

  // Doctor sessions always have a JS-readable cookie/localStorage token, so
  // its absence genuinely means no session. Patients authenticate via an
  // httpOnly accessToken cookie that JS can never read — token being null
  // does NOT mean logged out, so the doctor path may still bail out early,
  // but the patient path must ask the server (withCredentials sends the
  // httpOnly cookie automatically) rather than assume the session is dead.
  if (useDoctor && !token) return false;

  const url = useDoctor
    ? `${BASE_URLS.GATEWAY}${DOCTOR_SESSION_PROBE_PATH}`
    : `${BASE_URLS.USERS}${PATIENT_SESSION_PROBE_PATH}`;

  try {
    await sessionProbeClient.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    return true;
  } catch (error) {
    const status = error?.response?.status;
    // 401/403 sur /me => le jeton est bien invalide.
    if (status === 401 || status === 403) return false;
    // Reseau, 404, 5xx... : on ne deconnecte pas sur un doute.
    return true;
  }
};

const handlePossibleSessionExpiry = () => {
  if (sessionProbeRunning) return;
  sessionProbeRunning = true;

  isSessionStillValid()
    .then((valid) => {
      if (!valid) redirectToLogin();
      else if (isDev) {
        console.warn(
          "[API] 401 sur une ressource precise mais session valide - session conservee"
        );
      }
    })
    .catch(() => {})
    .finally(() => {
      sessionProbeRunning = false;
    });
};

const shouldRedirectToLogin = (error) => {
  const status = error?.response?.status;
  const message = String(
    error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      ""
  ).toLowerCase();

  if (status === 401) return true;
  if (message.includes("unauthorized")) return true;
  if (message.includes("invalid or missing authentication token")) return true;
  if (message.includes("jwt expired")) return true;
  if (message.includes("token expired")) return true;
  if (message.includes("invalid token")) return true;
  if (message.includes("missing authentication token")) return true;

  return false;
};

// ─── Factory d'instances axios ────────────────────────────────────────────────
//
// Options :
//   serviceName      : nom affiché dans les logs
//   sanitizeRequest  : (défaut true) retire des bodies les champs listés dans
//                      FORBIDDEN_REQUEST_FIELDS (userId, doctorId, id, role…).
//                      Mettre false pour un service dont les DTO exigent ces
//                      champs dans le body (ex. consultations).

const createInstance = (baseURL, options = {}) => {
  const opts = typeof options === "string" ? { serviceName: options } : options;
  const serviceName = opts.serviceName || "API";
  const shouldSanitizeRequest = opts.sanitizeRequest !== false;

  const instance = axios.create({
    baseURL: baseURL || BASE_URLS.GATEWAY || "",
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    ...opts.axiosOptions,
  });

  instance.interceptors.request.use((config) => {
    if (
      (config.sanitizeRequest ?? shouldSanitizeRequest) &&
      config &&
      config.data &&
      typeof config.data === "object" &&
      !(config.data instanceof FormData)
    ) {
      const allowedFields = new Set(
        Array.isArray(config.allowedRequestFields)
          ? config.allowedRequestFields.map((field) => String(field))
          : []
      );
      config.data = sanitizeRequestData(config.data, allowedFields);
    }
    return attachAuthHeader(config);
  }, (err) => Promise.reject(err));

  if (isDev && opts.enableDevLogging !== false) {
    instance.interceptors.request.use((cfg) => {
      return cfg;
    });
  }

  instance.interceptors.response.use(
    (res) => {
      if (isDev && opts.enableDevLogging !== false) {
      }
      return res;
    },
    (err) => {
      if (isDev && opts.enableDevLogging !== false) {
        console.warn(
          `[${serviceName} ✗]`,
          err?.response?.status,
          describeRequestUrl(err?.config),
          err?.message
        );
      }

      // Un 401 renvoye par une requete d'authentification publique (login,
      // verification 2FA, reset de mot de passe...) n'est pas une expiration
      // de session : c'est un identifiant/mot de passe invalide. Laisser le
      // code appelant (ex. useLoginPatient) gerer l'erreur localement, sans
      // declencher de redirection/hard reload qui ecraserait le message.
      const isPublicAuthFailure = isPublicAuthRequest(err?.config);

      // Assistant pages can trigger 401 on doctor-only endpoints (shared screens).
      // Do not force a global logout for assistant sessions.
      if (
        shouldRedirectToLogin(err) &&
        !isAssistantSession() &&
        !isPublicAuthFailure &&
        !getSessionLogoutRole()
      ) {
        // ✅ Idem pour un patient : consulter le profil d'un médecin appelle des
        // endpoints réservés au médecin. Un 401 sur ces routes ne signifie pas
        // que la session patient a expiré — on ne la détruit pas.
        const crossRole =
          isPatientOnlySession() && isDoctorOnlyUrl(describeRequestUrl(err?.config));

        if (!crossRole) {
          handlePossibleSessionExpiry();
        } else if (isDev) {
          console.warn(
            `[${serviceName}] 401 sur un endpoint médecin en session patient — session conservée`,
            describeRequestUrl(err?.config)
          );
        }
      }

      const rejectedUrl = describeRequestUrl(err?.config);
      const isMedicalAuthorizationFailure =
        ["medical", "medication", "extraction"].includes(serviceName) ||
        /(?:^|\/)(?:medical-information|extraction|medication)(?:\/|$)/i.test(
          rejectedUrl,
        );
      if (
        err?.response?.status === 403 &&
        isMedicalAuthorizationFailure &&
        typeof window !== "undefined"
      ) {
        window.dispatchEvent(
          new CustomEvent("medical-capabilities-invalidated", {
            detail: { patientId: null, doctorId: null },
          }),
        );
      }

      return Promise.reject(err);
    }
  );

  return instance;
};

// ─── Instance admin (sans intercepteur de redirection login) ──────────────────

const createAdminInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
  });

  // ✅ Attacher le token admin si présent
  instance.interceptors.request.use((cfg) => {
    const adminToken =
      Cookies.get("adminAccessToken") ||
      localStorage.getItem("adminAccessToken") ||
      null;

    if (adminToken) {
      cfg.headers = cfg.headers || {};
      cfg.headers.Authorization = `Bearer ${adminToken}`;
    }

    if (isDev) {
    }

    return cfg;
  });

  instance.interceptors.response.use(
    (res) => {
      if (isDev) {
      }
      return res;
    },
    (err) => {
      if (isDev) {
        console.warn(
          `[admin ✗]`,
          err?.response?.status,
          (err?.config?.baseURL || "") + (err?.config?.url || ""),
          err?.response?.data
        );
      }

      // ✅ Rediriger vers /LoginAdmin si 401
      if (err?.response?.status === 401) {
        const currentPath = window.location.pathname;
        if (currentPath !== "/LoginAdmin") {
          Cookies.remove("adminAccessToken");
          localStorage.removeItem("adminAccessToken");
          window.location.replace("/LoginAdmin");
        }
      }

      return Promise.reject(err);
    }
  );

  return instance;
};

// ─── Exports ──────────────────────────────────────────────────────────────────

export const axiosAdmin           = createAdminInstance(BASE_URLS.ADMIN);
export const axiosAuth            = createInstance(BASE_URLS.AUTH, { serviceName: "auth" });
export const axiosPosts           = createInstance(BASE_URLS.POSTS, { serviceName: "posts" });
export const axiosComments        = createInstance(BASE_URLS.COMMENTS, {
  serviceName: "comments",
  sanitizeRequest: false,
});
export const axiosLikes           = createInstance(BASE_URLS.LIKES, {
  serviceName: "likes",
  sanitizeRequest: false,
});
export const axiosMedication      = createInstance(BASE_URLS.MEDICATION, { serviceName: "medication" });
export const axiosMedicationsDatabase = createInstance(BASE_URLS.MEDICATIONS_DATABASE, { serviceName: "medicationsDatabase" });
export const axiosAnalyse         = createInstance(BASE_URLS.ANALYSE, { serviceName: "analyse" });
export const axiosSignal          = createInstance(BASE_URLS.SIGNAL, { serviceName: "signal" });
// ✅ Les DTO de prescription exigent patientId dans le body :
// on désactive le nettoyage des champs "interdits" pour cette instance.
export const axiosPrescription    = createInstance(BASE_URLS.PRESCRIPTION, {
  serviceName: "prescription",
  sanitizeRequest: false,
});
export const axiosEmergency       = createInstance(BASE_URLS.EMERGENCY, { serviceName: "emergency" });
export const axiosPlaces          = createInstance(BASE_URLS.PLACES, { serviceName: "places" });
export const axiosGateway         = createInstance(BASE_URLS.GATEWAY, { serviceName: "gateway" });
export const axiosUsers           = createInstance(BASE_URLS.USERS, { serviceName: "users" });
export const axiosMedical         = createInstance(BASE_URLS.MEDICAL, { serviceName: "medical" });
export const axiosRelatives       = createInstance(BASE_URLS.RELATIVES, { serviceName: "relatives" });
export const axiosCycles          = createInstance(BASE_URLS.CYCLES, { serviceName: "cycles" });
export const axiosVitals          = createInstance(BASE_URLS.VITALS, { serviceName: "vitals" });
export const axiosModeration      = createInstance(BASE_URLS.MODERATION.replace(/\/moderation\/?$/, ""), { serviceName: "moderation" });
export const axiosMessages        = createInstance(BASE_URLS.MESSAGES, { serviceName: "messages" });
export const axiosDoctorRegister  = createInstance(BASE_URLS.REGISTER_DOCTOR, { serviceName: "doctorRegister" });
export const axiosDoctorAuth      = createInstance(BASE_URLS.DOCTOR_AUTH, { serviceName: "doctorAuth" });
export const axiosDoctors         = createInstance(BASE_URLS.DOCTORS, { serviceName: "doctors" });
export const axiosExtraction      = createInstance(BASE_URLS.EXTRACTION, { serviceName: "extraction" });
export const axiosDisponibility   = createInstance(BASE_URLS.DISPONIBILITY, { serviceName: "disponibility" });
export const axiosRDV             = createInstance(BASE_URLS.RDV, {
  serviceName: "rdv",
  sanitizeRequest: false,
});
export const axiosDoctorProfile   = createInstance(BASE_URLS.DOCTORPROFILE, {
  serviceName: "doctorProfile",
  sanitizeRequest: false,
});
export const axiosAssistant       = createInstance(BASE_URLS.ASSISTANTS, { serviceName: "assistants" });
export const axiosAssistantPublic = axios.create({
  baseURL: BASE_URLS.GATEWAY,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});
export const axiosRadio = axios.create({
  baseURL: BASE_URLS.RADIO_BROWSER,
  withCredentials: false,
  timeout: 15000,
  headers: { Accept: "application/json" },
});
export const axiosWeather = axios.create({
  baseURL: BASE_URLS.WEATHER,
  withCredentials: false,
  timeout: 10000,
  headers: { Accept: "application/json" },
});
export const axiosHealthBot       = createInstance(BASE_URLS.HEALTHBOT, { serviceName: "healthBot" });

// ✅ Les DTO de consultation exigent userId / doctorId dans le body :
// on désactive le nettoyage des champs "interdits" pour cette instance.
export const axiosConsultation    = createInstance(BASE_URLS.CONSULTATION, {
  serviceName: "consultation",
  sanitizeRequest: false,
});
export const axiosSpeciality      = createInstance(BASE_URLS.SPECIALITY, {
  serviceName: "speciality",
});
export const axiosPulmonology     = createInstance(BASE_URLS.PULMONOLOGY, {
  serviceName: "pulmonology",
});

export const axiosEvents          = createInstance(BASE_URLS.EVENTS, { serviceName: "events" });
export const axiosNotifications   = createInstance(BASE_URLS.NOTIFICATIONS, { serviceName: "notifications" });
export const axiosFollows         = createInstance(BASE_URLS.FOLLOWS, { serviceName: "follows" });
export const axiosConnections     = createInstance(BASE_URLS.CONNECTIONS, { serviceName: "connections" });
export const axiosInterraction    = createInstance(BASE_URLS.INTERRACTION, { serviceName: "interraction" });
export const axiosSousProfile     = createInstance(BASE_URLS.SOUS_PROFILE, { serviceName: "sous-profiles" });
export const axiosCnss            = createInstance(BASE_URLS.CNSS, { serviceName: "cnss" });
export const axiosFeedback        = createInstance(BASE_URLS.FEEDBACK, { serviceName: "feedback" });

export const api = axiosGateway;
export default api;
